import { DynamicFormControlLayout, DynamicFormControlModelConfig, DynamicFormValueControlModel, serializable } from '@ng-dynamic-forms/core';

export const TYPE_NACHRICHT_REFERENT = 'NACHRICHT-REFERENT';
export const EVENT_TYPE_PRINT_PDF_INFOCLIENT = 'gsm-print-pdf-infoclient';

export interface NachrichtReferentModelConfig extends DynamicFormControlModelConfig {
  icon?: string;
  heading?: string;
  timestamp?: string[];
}

export class NachrichtReferentModel extends DynamicFormValueControlModel<any> {
  @serializable() readonly type: string = TYPE_NACHRICHT_REFERENT;

  @serializable() icon: string;
  @serializable() heading: string;

  constructor(config: NachrichtReferentModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);

    this.icon = config.icon || 'print';
    this.heading = config.heading || null;
  }
}
